/** @format */

import {
  Box,
  Divider,
  Drawer,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useUserContext } from "../../App";
import Config from "../../assets/svg/config";
import Location from "../../assets/svg/location";
import Px from "../../assets/svg/PX";
import Reputation from "../../assets/svg/reputation";
import Setter from "../../assets/svg/setter";
import { ScreenDimension } from "../../config/responsiveDimension";
import { updateAdminDetails, updateDrawer } from "../../redux/slice/userSlice";
import { RoutesPath } from "../../routes/RoutesPath";
import { DOMAIN_NAME } from "../../utils/config";
const SideBar = () => {
  const Navigation = useNavigate();
  const dispatch = useDispatch();
  const { MLG } = ScreenDimension();

  const location = useLocation().pathname;
  const permission = useSelector((state) => state.campaign.permission);
  const openDrawer = useSelector((state) => state.user.openDrawer);

  useEffect(() => {
    if (openDrawer) {
      dispatch(updateDrawer());
    }
  }, [location]);

  const removeSPace = (str) => {
    if (!str) return "";
    const value = str?.toLowerCase()?.replace(/\s+/g, "");
    return value;
  };
  const getSetterStatus =
    permission?.find((v) =>
      removeSPace(v?.mainMenu)?.includes(removeSPace("Campaigns"))
    )?.subMenus || [];
  const handleStatus = (str) => {
    const findStatus = getSetterStatus?.find((v) =>
      removeSPace(v?.menu)?.includes(removeSPace(str))
    )?.status;
    return findStatus === undefined ? true : findStatus;
  };
  const handleUrlStatus = (str) => {
    const findStatus = permission?.find((v) =>
      removeSPace(v?.mainMenu)?.includes(removeSPace(str))
    )?.status;
    return findStatus === undefined ? true : findStatus;
  };

  const sideBarContent = [
    {
      name: "Dashboard",
      navigation: RoutesPath.DASHBOARD,
      status: handleStatus("Dashboard"),
      url: "campaign",
    },
    {
      name: "SMS Campaign",
      navigation: RoutesPath.CAMPAIGNHISTORY,
      status: handleStatus("Sms Campaign"),
      url: "campaign",
    },
    {
      name: "List",
      navigation: RoutesPath.LIST,
      status: handleStatus("List"),
      url: "campaign",
    },
    {
      name: "Contact",
      navigation: RoutesPath.CONTACT,
      status: handleStatus("Contact"),
      url: "campaign",
    },
    {
      name: "Applications",
      status: true,
      url: "title",
    },

    {
      name: "Listings",
      icon: <Location />,
      navigation: DOMAIN_NAME.listing,
      status: handleUrlStatus("Listings"),
      url: "domain",
      img: "https://stage.layline.live/img/newIcons/listing.svg",
    },

    {
      name: "Reputation",
      icon: <Reputation />,
      navigation: DOMAIN_NAME.reputation,
      status: handleUrlStatus("Reputation"),
      url: "domain",
      img: "https://stage.layline.live/img/newIcons/ReputationIcon.svg",
    },
    {
      name: "Patient Experience",
      icon: <Px />,
      navigation: DOMAIN_NAME.patientExperience,
      status: handleUrlStatus("Patient Experience"),
      url: "domain",
      img: "https://stage.layline.live/img/newIcons/PatientExpIcon.svg",
    },

    {
      name: "Setter",
      icon: <Setter />,
      navigation: DOMAIN_NAME.setter,
      status: handleUrlStatus("Setter"),
      url: "domain",
      img: "https://stage.layline.live/img/newIcons/setter.svg",
    },
    {
      name: "Configuration",
      icon: <Config />,
      navigation: DOMAIN_NAME.config,
      status: handleUrlStatus("Admin"),
      url: "domain",
      img: "https://stage.layline.live/img/newIcons/config.svg",
    },
  ];

  const [expanded, setExpanded] = useState({});

  const toggleSubmenu = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const handleLogout = async () => {
    const pastDate = new Date(0);
    const expires = `expires=${pastDate.toUTCString()}`;
    const domainAttr = `domain=.layline.live`;
    document.cookie = `ssoToken=; ${expires}; ${domainAttr}; path=/;`;
    dispatch(updateAdminDetails([]));
    Navigation(RoutesPath.LOGIN);
  };

  const handleClose = () => {
    dispatch(updateDrawer());
  };

  const SideBarComponent = () => {
    const filterStatusSetter = sideBarContent?.filter(
      (v) => v?.url === "campaign" && v?.status
    );
    return (
      <SubContainer>
        <SideBarList pt={"2rem"}>
          {sideBarContent.map(
            (value, index) =>
              (value?.status || value?.url === "domain") && (
                <React.Fragment key={index}>
                  {value.name === "Applications" && (
                    <Divider
                      sx={{ mt: filterStatusSetter?.length < 4 ? 6 : 2 }}
                    />
                  )}
                  <NavLinkStyled
                    to={
                      !value?.status && value?.url === "domain"
                        ? "#"
                        : value.navigation
                    }
                    disabled={!value?.status && value?.url === "domain"}
                  >
                    <AddBorderLeft
                      disabled={!value?.status && value?.url === "domain"}
                      active={location?.includes(value?.navigation)}
                      isApplications={value.name === "Applications"}
                      sx={{
                        padding: `.${value?.url === "domain" ? 0 : 5}rem .7rem`,
                        my: value?.url === "domain" ? 0.7 : 0,
                      }}
                    >
                      {value?.img && (
                        <img
                          src={value.img}
                          alt={value.name}
                          width={38}
                          height={38}
                        />
                      )}
                      <Menus
                        sx={{
                          fontWeight:
                            value.name === "Applications" ? "bold" : "normal",
                        }}
                      >
                        {value.name}
                      </Menus>
                    </AddBorderLeft>
                  </NavLinkStyled>
                </React.Fragment>
              )
          )}
        </SideBarList>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box mb={1} width={"100%"}>
            <Divider />
          </Box>
          <Box
            sx={{
              padding: 1,
              cursor: "pointer",
              display: "flex",
              width: "60%",
              justifyContent: "center",
              ":hover": {
                background: "#EAEEF0",
                borderRadius: "8px",
              },
            }}
            onClick={handleLogout}
          >
            <Menus>Sign Out</Menus>
          </Box>
        </Box>
      </SubContainer>
    );
  };

  return MLG ? (
    <Container>
      <SideBarComponent />
    </Container>
  ) : (
    <DrawerContainer open={openDrawer} onClose={handleClose}>
      <SideBarComponent />
    </DrawerContainer>
  );
};

export default SideBar;

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  overflowY: "auto",
  height: "100%",
  width: "16%",
  position: "sticky",
  top: 0,
  // boxShadow: "0px 40px 40px 40px #00000029",
}));

const DrawerContainer = styled(Drawer)(({ theme }) => ({}));
const SubContainer = styled(Box)(() => ({
  transition: "width 0.3s ease-in-out",
  backgroundColor: "#FDFDFD",
  width: "100%",

  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%",
}));

const Menus = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.black,
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

const SideBarList = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  height: "100%",
  overflow: "auto",
}));

const NavLinkStyled = styled(NavLink)(({ disabled = false }) => ({
  textDecoration: "none",
  color: "#454545",
  display: "flex",
  alignItems: "center",
  padding: "0px 10px",
  "&.active": {
    transition: "all 0.3s ease-in-out",
  },
  pointerEvents: disabled ? "none" : "auto",
}));

const AddBorderLeft = styled(Box)(
  ({ active, isApplications, disabled = false }) => ({
    background: active ? "#eaeef0" : "transparent",
    position: "relative",
    display: "flex",
    gap: "4px",
    alignItems: "center",
    // borderBottomRightRadius: active ? "16px" : "0px",
    // borderTopRightRadius: active ? "16px" : "0px",
    width: "100%",
    transition: "all 0.3s",

    fontSize: "16px",
    fontWeight: "500",
    opacity: disabled ? 0.5 : 1,
    marginLeft: "10px !important",
    marginRight: "10px !important",
    borderRadius: 10,

    "&:before": {
      position: "absolute",
      content: '""',
      left: 0,
      top: 0,
      bottom: 0,
      right: "99%",
    },
    ":hover": isApplications
      ? {}
      : {
          background: "#eaeef0",
          // borderBottomRightRadius: "16px",
          // borderTopRightRadius: "16px",
        },
  })
);
